<script>

import axios from 'axios'

export default {
  props: {
    id: {
      type: String,
      default: "multicolumn"
    },
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    range: {
			type: Boolean,
			default: false
    },
    error: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 10
    },
    collection: "",
    show_last_modification: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      name: window.name,
      source_type: null,
      reference: null,
      execute: null,
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000,
      modalTitle: "",
      columns: [],
      data: [],
      max: 0,
      severityColors: {
        critical: '#7A0012',
        high: '#DC001E',
        medium: '#FECA00',
        low: '#01AD00'
      },
      elements_results: [],
      last_update: '',
      padding_top: '20px'
    }
  },
  methods: {
    // Column widths arrive as "12%" or as a bare "10". In a fixed-layout table
    // a bare number is read as pixels, which would crush the column, so a bare
    // number is treated as the percentage it was always meant to be.
    colWidth (column) {
      const w = column.width
      if (w === undefined || w === null || w === '') return undefined
      return /^\d+(\.\d+)?$/.test(String(w)) ? `${w}%` : w
    },
    // "8/31/2026, 7:20:41 PM" as two pieces so the cell breaks between date and
    // time at most once, instead of splitting the time itself across lines.
    dateParts (value) {
      const text = new Date(value['$date']).toLocaleString() || 'N/A'
      const parts = text.split(', ')
      return parts.length === 2 ? [parts[0] + ',', parts[1]] : [text]
    },
    // Free text may fold inside its column (a long URL has to); a number never
    // should, or an ID reads as two lines of digits in a narrow column.
    cellNoWrap (column, entry) {
      if (column.type === 'number' || column.type === 'icon') return true
      const value = entry[column.reference]
      return value !== null && value !== '' && value !== undefined && !isNaN(value)
    },
    formatEntry(value, limit) {
      if (limit === undefined) limit = 20
      if (value.length > limit) {
        return value.substring(0, limit) + '...'
      } else {
        return value
      }
    },
    imageName: function (column, value) {
      return `${column.path}/${value}.${column.extension}`;
    },
    numeralFormat: function (number) {
      return (Math.round(number * 100) / 100).toLocaleString()
    },
    getBarStyle: function (column, value, entry) {
      if (isNaN(value) || value === null) return;
      // The scale has to come from every row, not from the rows drawn so far.
      // Growing the maximum as it went meant the first row was always 100%,
      // which only looked right while the data happened to arrive sorted
      // descending - any other order produced a chart of full-width bars.
      var max = 0
      this.data.forEach(function (row) {
        var v = row[column.reference]
        if (!isNaN(v) && v > max) max = v
      })
      if (max === 0) return;
      var style = {
        height: "100%",
        padding: "6px",
        // The colour is set here rather than through a severity class on the
        // element. Several components in this app ship non-scoped stylesheets
        // that define .high / .medium / .low with `background-color …
        // !important`, which leaks across the whole page: it painted these
        // bars whatever colour it liked and left `critical` - which none of
        // them define - on the default blue.
        backgroundColor: this.severityColors[entry && entry.severity] || "#0084FF"
      };
      style.width = Math.round((value*100)/max).toString()+'%';
      return style;
    },
    getMultiBarKey: function(column, entry, key) {
      var ent = entry;
      var out = [];
      try {
        column.source.map(function(src){
          ent = ent[src];
        });
      } catch (e) {
        console.error('Entry by source not found.' + e);
      }
      if (ent === undefined || ent.length < 1) {
        return
      }

      var max = 0;
      this.data.map(function(dataEntry) {
        if (!isNaN(dataEntry[column.reference])) {
          if (dataEntry[column.reference] > max) {
            max = dataEntry[column.reference];
          }
        }
      });
      if (max === 0) return;

      let style = {};
      let width = "0%";
      const index = column.keys.indexOf(key);
      style.backgroundColor = column.colors[index];
      ent.map(function(e){
        if (e.key == key) {
          var val = (e[column.reference] === undefined) ? 0 : e[column.reference];
          width = Math.round((val*100)/max).toString()+'%';
          style.height = "100%";
          style.padding = "6px 1px";
        }
      });
      style.width = width;
      return style;
    },
    getData: function () {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (that.source === undefined) {
        console.error('MultiColumn Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'

      let source = that.source
      if (that.range) {
        if (that.start > 0) source = source + '&start=' + that.start.toString()
        if (that.end > 0) source = source + '&end=' + that.end.toString()
      }
      source = source.replace('{$limit}', that.limit.toString())
      axios
      .get(baseURL + source)
      .then(function (response) {
          if (response.status === 200) {
            if (response.data.data === undefined) {
              console.error('MultiColumn Error - data not defined in source file.')
              return
            }
            if (response.data.columns === undefined) {
              console.error('MultiColumn Error - columns array not defined in source file.')
              return
            }
            that.columns = response.data.columns
            that.data = response.data.data.slice(0, that.limit)
            that.$emit('finished', that.id, true, `Data Length: ${that.data.length}`)
          }
          else if (response.status === 404) {
            console.error('MultiColumn Error - Source file not found.');
            that.$emit('finished', that.id, false, 'MultiColumn Error - Source file not found.')
          }
      })
			.catch(function (error) {
        console.error('Error loading multicolumn widget file definition. Error:', error.response)
        that.$emit('finished', that.id, false, error.response)
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			})
    }
  },
  created: function() {
    this.getData()
  }
}
</script>

<template>
  <div style="padding-right: 20px; padding-bottom: 20px; padding-left: 20px;" :style="{ 'padding-top': padding_top }">
  <span v-if="show_last_modification" class="widget_show_dates">Last Update: {{ last_update.toLocaleString('en-GB').replace(',','')  }}</span>
    <template v-if="data !== undefined && data.length > 0 && columns !== undefined && columns.length > 0">
      <table style="width:100%" class="mc_table">
        <thead>
          <th v-for="(column, index) in columns" :width="colWidth(column)" v-bind:key="index">
            {{ column.name }}
          </th>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in data" v-bind:key="index">
            <template v-if="columns !== undefined && columns.length > 0">
              <td v-for="(column, cindex) in columns" :class="[column.class, cellNoWrap(column, entry) ? 'mc_nowrap' : '']" :width="colWidth(column)" v-bind:key="cindex">
                <template v-if="column.type === 'image'">
                  <img :src="imageName(column, entry[column.reference])" :width="column.image_width"/>
                </template>
                <template v-else-if="column.type === 'number'">
                  <!-- classPositive only kicks in above zero: a count of
                       breaches is good news at 0, and painting that red reads
                       as the opposite of what it means. -->
                  <span :class="[column.class, (column.classPositive && entry[column.reference] > 0) ? column.classPositive : '']">
                    {{ numeralFormat(entry[column.reference]) }}
                  </span>
                </template>
                <template v-else-if="column.type === 'bar'">
                  <div :style="getBarStyle(column, entry[column.reference], entry)" />
                </template>
                <template v-else-if="column.type === 'multibar'">
                  <div style="display: flex; flex-direction: row; flex-wrap: nowrap; height:100%; width:100%;">
                    <div v-for="(key, bindex) in column.keys" :style="getMultiBarKey(column, entry, key)" v-bind:key="bindex"></div>
                  </div>
                </template>
                <template v-else-if="column.type === 'datetime'">
                  <template v-if="entry[column.reference] !== undefined && entry[column.reference] !== null">
                    <!-- Two pieces, each unbreakable, with a real space between
                         them: that space is the only place the cell may wrap.
                         A v-for would render the pieces with nothing between
                         them and the line could not break at all. -->
                    <span class="mc_nowrap">{{ dateParts(entry[column.reference])[0] }}</span>{{ ' ' }}<span
                      v-if="dateParts(entry[column.reference])[1]"
                      class="mc_nowrap"
                    >{{ dateParts(entry[column.reference])[1] }}</span>
                  </template>
                </template>
                <template v-else-if="column.type === 'replace'">
                  <template v-if="entry[column.reference] !== undefined && entry[column.reference] !== null">
                    {{ column.replace[entry[column.reference]] }}
                  </template>
                </template>
                <template v-else-if="column.type === 'icon' && (entry[column.reference] !== undefined && entry[column.reference] !== null)">
                  <span :class="column.classes[entry[column.reference].split('_')[0]]">
                    <i class="uil" :class="column.icons[entry[column.reference].split('_')[0]]" style="padding-top:3px;" />&nbsp;
                  </span>
                </template>
                <template v-else>
                  <template v-if="entry[column.reference] !== undefined && entry[column.reference] !== null">
                    <span :class="column.class" :id="'id_' + entry[column.reference]">
                      {{ formatEntry(entry[column.reference] || "N/A", column.maxlength || 25 )}}
                    </span>
                    <b-tooltip :target="'id_' + entry[column.reference]" triggers="hover">
                        {{ entry[column.reference] || "N/A"}}
                    </b-tooltip>
                  </template>
                </template>
              </td>
            </template>
            <template v-else>

            </template>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div id="multicolumn-empty">
        <span class="short_widget" id="multicolumn-empty-span">
          {{ error }}
        </span>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .mc_table {
    width: 100%;
    /* Fixed layout is what makes the widths below binding. In automatic layout
       a cell holding an unbreakable string (a 300-character URL) widens its
       column until the string fits, and the table runs out of the card. */
    table-layout: fixed;
    border: 1px;
    border-color: black;
    line-height: 18px !important;
  }

  .mc_table th,
  .mc_table td {
    /* Break anywhere inside a word when there is no space to break at, so a
       long URL folds inside its column instead of pushing past it. */
    overflow-wrap: anywhere;
    word-break: break-word;
    vertical-align: top;
  }

  .mc_nowrap {
    white-space: nowrap;
  }

  .mc_table tr{
    height: 20px !important;
    border-top-color: #f0f0f0;
    border-top-width: 1px;
    border-top-style: solid;
    border-bottom-color: #f0f0f0;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .high {
    color: #DC001E;
    /* fill: #DC001E; */
    /* background-color: #DC001E !important; */
    border: 0px !important;
  }

  .medium {
    color: #FECA00;
    /* fill: #FECA00; */
    /* background-color: #FECA00 !important; */
    border: 0px !important;
  }

  .low {
    color: #01AD00;
    /* fill: #01AD00; */
    /* background-color: #01AD00 !important; */
    border: 0px !important;
  }

  /* Text-only severity colours. They are deliberately not called .critical or
     .high: those names are claimed by non-scoped stylesheets elsewhere in the
     app that set a red background with !important, which turned these cells
     into solid blocks with the number hidden inside them. */
  .sev-critical {
    color: #7A0012;
  }

  .sev-high {
    color: #DC001E;
  }

  .reference {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .value {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .tleft {
    text-align: left;
  }

  .tcenter {
    text-align: center;
  }
</style>
